<div class="sup-chat-root">
  <div *ngIf="toast" class="sup-toast">{{ toast }}</div>

  <header class="sup-chat-header">
    <div>
      <h2>Live Chat Monitor</h2>
      <p>Supervisor view of active and closed citizen handoff conversations</p>
    </div>
    <div class="header-actions">
      <span class="status-chip"><span></span>{{ activeCount }} Active</span>
      <div class="mode-toggle">
        <button [class.active]="viewMode === 'active'" (click)="setViewMode('active')">Active</button>
        <button [class.active]="viewMode === 'history'" (click)="setViewMode('history')">History</button>
      </div>
      <button class="refresh-btn" (click)="loadSessions()"><i class="material-icons">refresh</i> Refresh</button>
    </div>
  </header>

  <div class="sup-chat-shell">
    <aside class="session-list">
      <div class="session-search">
        <i class="material-icons">search</i>
        <input [(ngModel)]="query" placeholder="Search citizen, agent, mobile..." />
      </div>

      <div *ngIf="loading" class="empty-list">Loading live chats...</div>
      <div *ngIf="!loading && filteredSessions.length === 0" class="empty-list">
        {{ viewMode === 'history' ? 'No chat history found.' : 'No active live chats.' }}
      </div>

      <button *ngFor="let session of filteredSessions" class="session-card" [class.active]="selected?.id === session.id"
              (click)="selectSession(session)">
        <div class="session-card-top">
          <strong>{{ session.citizenName || 'Citizen' }}</strong>
          <span [class.closed]="session.status === 'CLOSED'">{{ session.status }}</span>
        </div>
        <div class="session-meta">
          {{ session.citizenMobile || 'No mobile' }} · {{ session.assignedAgentName || 'Unassigned' }}
          <ng-container *ngIf="session.assignedAgentExtension"> · Ext {{ session.assignedAgentExtension }}</ng-container>
        </div>
        <div class="session-question">{{ session.sourceQuestion || 'Live chat request' }}</div>
        <time>{{ formatTime(session.lastMessageAt || session.createdAt) }}</time>
      </button>
    </aside>

    <section class="conversation">
      <ng-container *ngIf="selected; else noSelection">
        <header class="conversation-header">
          <div>
            <h3>{{ selected.citizenName || 'Citizen' }}</h3>
            <p>
              {{ selected.citizenMobile || 'No mobile' }} ·
              Agent: {{ selected.assignedAgentName || 'Unassigned' }}
              <ng-container *ngIf="selected.assignedAgentExtension"> · Ext {{ selected.assignedAgentExtension }}</ng-container>
            </p>
          </div>
          <div class="conversation-actions">
            <button class="transfer-chat-btn" [disabled]="selected.status === 'CLOSED'" (click)="openTransfer()">
              <i class="material-icons">swap_horiz</i> Transfer
            </button>
            <span class="status-pill" [class.closed]="selected.status === 'CLOSED'">{{ selected.status }}</span>
          </div>
        </header>

        <div *ngIf="transferOpen" class="transfer-panel">
          <label>Transfer to</label>
          <select [(ngModel)]="transferTargetUserId" [disabled]="transferLoading || transferring">
            <option [ngValue]="null">{{ transferLoading ? 'Loading agents...' : 'Select internal user' }}</option>
            <option *ngFor="let user of availableTransferUsers" [ngValue]="user.userId">
              {{ user.name || user.userName || user.email || ('User #' + user.userId) }}
            </option>
          </select>
          <button class="transfer-confirm-btn" [disabled]="!transferTargetUserId || transferring" (click)="transferChat()">
            {{ transferring ? 'Transferring...' : 'Confirm Transfer' }}
          </button>
        </div>

        <div class="conversation-body">
          <div *ngFor="let msg of messages" class="msg" [class.agent]="msg.senderType === 'AGENT'"
               [class.system]="msg.senderType === 'SYSTEM'">
            <div class="msg-name">{{ msg.senderName || msg.senderType }}</div>
            <div class="msg-text">{{ msg.messageText }}</div>
            <time>{{ formatTime(msg.createdAt) }}</time>
          </div>
        </div>
      </ng-container>

      <ng-template #noSelection>
        <div class="no-selection">
          <i class="material-icons">forum</i>
          <h3>No chat selected</h3>
          <p>Select a live chat to inspect the conversation.</p>
        </div>
      </ng-template>
    </section>
  </div>
</div>
